// All callers use canonical /api/... routes. Accept an origin or origin/api
// configuration without appending a second /api prefix.
export function apiBase(configured) {
  const value = (configured ?? '').trim().replace(/\/+$/, '');
  if (!value || value === '/api') return '';
  const url = new URL(value);
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password
      || url.search || url.hash || !['', '/', '/api'].includes(url.pathname)) {
    throw new Error('API base must be an HTTP(S) origin, optionally ending in /api');
  }
  return url.origin;
}
